import { render, staticRenderFns } from "./add-sales.vue?vue&type=template&id=999088b0&scoped=true&"
import script from "./add-sales.vue?vue&type=script&lang=ts&"
export * from "./add-sales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999088b0",
  null
  
)

export default component.exports